import { useEffect, useRef } from 'react';
import isEqual from 'lodash.isequal';

const useDifferFormEntry = (
    prevValues?: { [key: string]: any },
    formValues?: { [key: string]: any },
    formEntryHasChanged?: Function
) => {
    if (formEntryHasChanged) {
        const prevFormValues = useRef({});
        const firstTime = useRef(true);

        useEffect(() => {
            if (Object.keys(prevValues)?.length) {
                prevFormValues.current = prevValues;
            } else if (
                !Object.keys(prevFormValues.current)?.length &&
                Object.keys(formValues)?.length
            ) {
                prevFormValues.current = { ...formValues };
            }
        }, [formValues, prevFormValues.current, prevValues]);

        useEffect(() => {
            if (Object.keys(formValues).length && Object.keys(prevFormValues.current).length) {
                if (!isEqual(formValues, prevFormValues.current) && firstTime.current) {
                    formEntryHasChanged(true);
                    firstTime.current = false;
                } else if (isEqual(formValues, prevFormValues.current) && !firstTime.current) {
                    formEntryHasChanged(false);
                    firstTime.current = true;
                }
            }
        }, [formValues, prevFormValues.current, firstTime.current]);
    }
};

export default useDifferFormEntry;
